import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Icon } from 'rsuite';

// components
import FormLabel from './FormLabel';
import FormError from './FormError';
// styles
import styles from './InputWrapper.module.less';
import { copyToClipboard } from '../../utils/copyToClipboard';
import PopoverIcon from '../PopoverIcon/PopoverIcon';

export const InputWrapper = ({
  label = '',
  errorMessage = '',
  isHidden = false,
  largeLabel = false,
  boldLabel = false,
  hasCopyButton,
  children,
  badgeComponent = null,
  upgradePrompt = '',
  inputText
}) => {
  const handleCopyContent = async (e, content) => {
    e.stopPropagation();
    e.preventDefault();

    await copyToClipboard(content);

    Alert.info('Copied text to clipboard');
  };

  return (
    <section
      className={`${styles.inputWrapper} ${isHidden ? styles.vpHiddenInput : ''} ${
        hasCopyButton ? styles.vpRelativeWrapper : ''
      }`}>
      <div className={styles.vpBadgeContainer}>
        <FormLabel largeLabel={largeLabel} boldLabel={boldLabel}>{label}</FormLabel>
        {badgeComponent}
        {upgradePrompt && <PopoverIcon popoverContent={upgradePrompt} />}
      </div>
      {children}
      <FormError>{errorMessage}</FormError> 
      {hasCopyButton && <a
        className={styles.vpCopyTranscriptionButton}
        role="button"
        onClick={(e) => handleCopyContent(e, inputText)}>
        <Icon icon="copy" className={styles.vpCopyTranscriptionIcon} />
      </a>}
    </section>
  );
};

InputWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.string,
  label: PropTypes.string,
  isHidden: PropTypes.bool,
  largeLabel: PropTypes.bool,
  boldLabel: PropTypes.bool,
  badgeComponent: PropTypes.element,
};

export default InputWrapper;



// WEBPACK FOOTER //
// ./src/components/HookFormInputs/InputWrapper.jsx